jQuery(document).ready(function($){
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Trigger: Close Modal
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  // $(document).on('click', '.js-close-modal', function () {
  //     var modal = $(this).closest('.m-modal'),
  //         iframe = modal.find('.a-iframe');

  //     modal.removeClass('m-modal--open');

  //     if (iframe[0]) {
  //         iframe.attr('src', '');
  //     }
  // });


  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡ 
  // ✅ Molecule: Modal
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡ 

  function closeModal(el) {
      const $modal    = $(el).closest(".m-modal");
      const triggerId = $modal.data("controlledby");
      const $media    = $modal.find('audio');

      $modal
          .removeClass("m-modal--open")
          .attr("tabindex", "-1");

      if (triggerId) {
          $(`#${triggerId}`)
              .removeClass('m-modal-trigger__trigger--active')
              .focus();
      }

      if ($media[0]) {
          $media.trigger('pause');
          $media.prop("currentTime", 0);
      }
  }

  function openModal(id, focusOnModal) {
      const $modal = $(`#${id}`);

      $modal
          .addClass("m-modal--open")
          .attr("tabindex", "1");

      if (focusOnModal) {
          setTimeout(function () {
            //   $modal.focus();
          }, 100);
      } else {
          const $focusable = $modal.find(
              'button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'
          );
          const $firstFocusable = $focusable[1];

          setTimeout(function () {
              $firstFocusable.focus();
          }, 100);
      }
  }

  function toggleModal(el, id, focusOnModal) {
      const $modal = $(`#${id}`);

      if ($modal.hasClass('m-modal--open')) {
          closeModal($modal.find('*:first'));
      } else {
          openModal(id, focusOnModal);
      }
  }

  if ($(".m-modal")[0]) {
      $(".m-modal__close, .m-modal__overlay").click(function () {
          closeModal(this);
      });

      $('.m-modal button, [href], .m-modal input:not([type="hidden"]), .m-modal select, .m-modal textarea, .m-modal [tabindex]:not([tabindex="-1"]), .m-modal').blur(function (e) {
          if (e.relatedTarget === null ||
              (
                  !$(e.relatedTarget).closest('.m-modal')[0] &&
                  !$(e.relatedTarget).is('.m-modal') &&
                  !$(e.relatedTarget).is('.m-modal-trigger__trigger')
              )
          ) {
              closeModal(this);
          }
      });

      $(".m-modal").keydown(function (e) {
          if (e.key === "Tab") {
              const $focusable = $(this).find(
                  'button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'
              );

              const $firstFocusable = $focusable[0];
              const $lastFocusable  = $focusable[$focusable.length - 1];

              if (
                  $(e.target).is($lastFocusable) && !e.shiftKey ||
                  ($(e.target).is($firstFocusable) && e.shiftKey)
              ) {
                  e.preventDefault();

                  if ($(e.target).is($lastFocusable)) {
                      $firstFocusable.focus();
                  } else {
                      $lastFocusable.focus();
                  }
              } else if ($(e.target).is(".m-modal")) {
                  e.preventDefault();

                  $firstFocusable.focus();
              }
          } else if (e.key === "Escape" || e.key === "Esc") {
              if (!$(e.target).is('.a-select *')) {
                  closeModal(this);
              }
          }
      });
  }


  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Molecule: Modal Trigger
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  if ($(".m-modal-trigger__trigger")[0]) {
      $(".m-modal-trigger__trigger").on('mousedown click', function () {
          const modalId = $(this).attr("aria-controls");
          const index   = parseInt($(this).data('index'));
          const $slider = $('.m-staff-slider__wrapper');

          console.log( $slider );
          console.log( index );
          $(this).toggleClass('m-modal-trigger__trigger--active');
          toggleModal(this, modalId, true);

          if($slider){
            if(index !== 0){
                $slider[0].slick.slickGoTo(index);
            }else{
                $slider[0].slick.slickGoTo(0);
            }
          }
      });

      $(".m-modal-trigger__trigger").keydown(function (e) {
          if (e.key === 'Enter' || e.key === 'spacebar' || e.key === ' ') {
              e.preventDefault();

              const modalId = $(this).attr("aria-controls");

              $(this).addClass('m-modal-trigger__trigger--active');
              openModal(modalId);
          }
      });
  }
});
